var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGenerator(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.336,
    height: 29.403,
    viewBox: "0 0 29.336 29.403",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_782",
    "data-name": "Group 782",
    transform: "translate(5155 4121.106)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_653",
    "data-name": "Rectangle 653",
    d: "M1.067.474a.593.593,0,0,0-.593.593v17.9a.593.593,0,0,0,.593.593h27.2a.593.593,0,0,0,.593-.593V1.067a.593.593,0,0,0-.593-.593H1.067m0-.474h27.2a1.067,1.067,0,0,1,1.067,1.067v17.9a1.067,1.067,0,0,1-1.067,1.067H1.067A1.067,1.067,0,0,1,0,18.965V1.067A1.067,1.067,0,0,1,1.067,0Z",
    transform: "translate(-5155 -4113.935)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M-5707.432-3825.054h-22.832l-.021-.215a2.224,2.224,0,0,0-.421-1.021,4.957,4.957,0,0,0-1.121-.953l.248-.4a5.343,5.343,0,0,1,1.25,1.069,2.7,2.7,0,0,1,.481,1.051h22.215a2.8,2.8,0,0,1,.4-.946,5.839,5.839,0,0,1,1.144-1.147l.286.378a5.472,5.472,0,0,0-1.035,1.032,2.236,2.236,0,0,0-.356.939l-.018.217Z",
    transform: "translate(578.2 -266.649)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M-2.12.474c-.443,0-.672.7-.731.908A5.2,5.2,0,0,0-2.79,3.9c.218.78.512.78.669.779H6.592a.653.653,0,0,0,.652-.652V3.149h3.714a3.789,3.789,0,0,0,.961-.718,3.253,3.253,0,0,0,.289-.39H7.244V1.126A.653.653,0,0,0,6.592.474H-2.12m0-.474H6.592A1.126,1.126,0,0,1,7.718,1.126v.44h5.275a4.723,4.723,0,0,1-.718,1.177,4.465,4.465,0,0,1-1.2.88H7.718V4.03A1.126,1.126,0,0,1,6.592,5.156H-2.12c-.349,0-.845-.119-1.126-1.126a5.679,5.679,0,0,1-.062-2.775C-3.127.605-2.742,0-2.12,0Z",
    transform: "translate(-5142.982 -4121.106)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M-5569.323-4276.349a7.147,7.147,0,0,1-.529-2.473,6.848,6.848,0,0,1,.506-2.383c.055-.14.535-.047.535-.047a6.67,6.67,0,0,0-.567,2.43,6.98,6.98,0,0,0,.568,2.47Z",
    transform: "translate(425.825 160.278)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M-5569.323-4275.874a7.153,7.153,0,0,1-.529-2.473,6.848,6.848,0,0,1,.506-2.383l.535-.047a6.67,6.67,0,0,0-.567,2.43,6.973,6.973,0,0,0,.568,2.47Z",
    transform: "translate(429.855 159.771)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M-5569.342-4276.728a7.109,7.109,0,0,1-.51-2.424,6.889,6.889,0,0,1,.526-2.432c.045-.111.515,0,.515,0a6.67,6.67,0,0,0-.567,2.43,6.98,6.98,0,0,0,.568,2.47Z",
    transform: "translate(432.344 160.577)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M-5720.928-4141.971h-.475V-4162h.475Z",
    transform: "translate(568.334 48.065)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M-5720.928-4141.971h-.475V-4162h.475Z",
    transform: "translate(593.605 48.067)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_657",
    "data-name": "Rectangle 657",
    d: "M.474.474v1.6H1.719V.474H.474M.415,0H1.778a.415.415,0,0,1,.415.415V2.134a.415.415,0,0,1-.415.415H.415A.415.415,0,0,1,0,2.134V.415A.415.415,0,0,1,.415,0Z",
    transform: "translate(-5150.97 -4109.964)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_656",
    "data-name": "Rectangle 656",
    d: "M.948.474A.475.475,0,0,0,.474.948V3.2a.475.475,0,0,0,.474.474H3.734A.475.475,0,0,0,4.208,3.2V.948A.475.475,0,0,0,3.734.474H.948M.948,0H3.734a.948.948,0,0,1,.948.948V3.2a.948.948,0,0,1-.948.948H.948A.948.948,0,0,1,0,3.2V.948A.948.948,0,0,1,.948,0Z",
    transform: "translate(-5146.881 -4109.964)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_658",
    "data-name": "Rectangle 658",
    d: "M.474.474v1.6H1.719V.474H.474M.415,0H1.778a.415.415,0,0,1,.415.415V2.134a.415.415,0,0,1-.415.415H.415A.415.415,0,0,1,0,2.134V.415A.415.415,0,0,1,.415,0Z",
    transform: "translate(-5150.97 -4100.423)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_654",
    "data-name": "Rectangle 654",
    d: "M.474.474v1.6H1.719V.474H.474M.415,0H1.778a.415.415,0,0,1,.415.415V2.134a.415.415,0,0,1-.415.415H.415A.415.415,0,0,1,0,2.134V.415A.415.415,0,0,1,.415,0Z",
    transform: "translate(-5131.769 -4109.964)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_655",
    "data-name": "Rectangle 655",
    d: "M.474.474v1.6H1.719V.474H.474M.415,0H1.778a.415.415,0,0,1,.415.415V2.134a.415.415,0,0,1-.415.415H.415A.415.415,0,0,1,0,2.134V.415A.415.415,0,0,1,.415,0Z",
    transform: "translate(-5131.769 -4100.423)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M-5652.437-4128.686h-.474v-1.628l-18.734-.037v1.648h-.475v-2.123l19.683.039Z",
    transform: "translate(522.032 18.738)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M-5348.026-4044.977h-.474V-4052h.474Z",
    transform: "translate(217.591 -55.416)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M-5348.026-4044.977h-.474V-4052h.474Z",
    transform: "translate(198.389 -55.416)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M-5652.825-3888.693H-5672.5V-3891h.475v1.833h18.726v-1.825h.475Z",
    transform: "translate(522.389 -206.875)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M-5470.906-3961.264h-4.575a.237.237,0,0,1-.237-.237.237.237,0,0,1,.237-.237h4.575a.237.237,0,0,1,.237.237A.237.237,0,0,1-5470.906-3961.264Z",
    transform: "translate(337.27 -140.328)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M-5470.906-3961.264h-4.575a.237.237,0,0,1-.237-.237.237.237,0,0,1,.237-.237h4.575a.237.237,0,0,1,.237.237A.237.237,0,0,1-5470.906-3961.264Z",
    transform: "translate(337.27 -138.26)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M-5470.906-3961.264h-4.575a.237.237,0,0,1-.237-.237.237.237,0,0,1,.237-.237h4.575a.237.237,0,0,1,.237.237A.237.237,0,0,1-5470.906-3961.264Z",
    transform: "translate(337.27 -136.192)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M-5509.526-4110.768H-5510v-16.05h.474Z",
    transform: "translate(369.52 14.968)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M-5483.689-4193.942h-.475V-4196h.475Z",
    transform: "translate(345.215 80.03)",
    fill: "#084688"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M-5483.689-4193.942h-.475V-4196h.475Z",
    transform: "translate(341.185 80.023)",
    fill: "#084688"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerator);
export default __webpack_public_path__ + "static/media/generator.d33909c2.svg";
export { ForwardRef as ReactComponent };